var _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCottage = function SvgCottage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 69,
      height: 68,
      viewBox: "0 0 69 68",
      fill: "none",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9 63.7487C9 62.9663 9.63426 62.332 10.4167 62.332L64.25 62.332C65.0324 62.332 65.6667 62.9663 65.6667 63.7487C65.6667 64.5311 65.0324 65.1654 64.25 65.1654L10.4167 65.1654C9.63426 65.1654 9 64.5311 9 63.7487Z"
    })), _ref3 || (_ref3 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.91666 63.7487C1.91666 62.9663 2.55092 62.332 3.33332 62.332L6.16666 62.332C6.94906 62.332 7.58332 62.9663 7.58332 63.7487C7.58332 64.5311 6.94906 65.1654 6.16666 65.1654L3.33402 65.1654C2.55161 65.1654 1.91666 64.5311 1.91666 63.7487Z"
    })), _ref4 || (_ref4 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.99382 43.8122L10.3527 44.6977L9.66622 45.3622C9.07914 45.9305 8.71694 46.7227 8.71694 47.6019C8.71694 47.838 8.74295 48.0663 8.7917 48.2848L8.93978 48.9486L8.5145 49.4793C7.93125 50.207 7.58333 51.1281 7.58333 52.1344C7.58333 54.2402 9.11495 55.9884 11.125 56.3256V53.8346C11.125 53.4434 11.4421 53.1263 11.8333 53.1263C12.2245 53.1263 12.5417 53.4434 12.5417 53.8346V56.3256C14.5517 55.9884 16.0833 54.2402 16.0833 52.1344C16.0833 51.1283 15.7355 50.2074 15.1525 49.4797L14.7273 48.9489L14.8754 48.2852C14.9242 48.0666 14.9503 47.8381 14.9503 47.6019C14.9503 46.7224 14.5879 45.9301 14.0006 45.3618L13.314 44.6974L13.6727 43.8119C13.765 43.584 13.8165 43.3338 13.8165 43.068C13.8165 41.9726 12.9286 41.0846 11.8332 41.0846C10.7378 41.0846 9.84986 41.9726 9.84986 43.068C9.84986 43.3339 9.90144 43.5843 9.99382 43.8122ZM12.5417 57.7572C15.337 57.4086 17.5 55.0241 17.5 52.1344C17.5 50.7948 17.0352 49.5638 16.2581 48.5939C16.3293 48.2746 16.3669 47.9426 16.3669 47.6019C16.3669 46.3231 15.8374 45.1679 14.9857 44.3438C15.1453 43.9498 15.2332 43.5192 15.2332 43.068C15.2332 41.1902 13.711 39.668 11.8332 39.668C9.95543 39.668 8.4332 41.1902 8.4332 43.068C8.4332 43.5194 8.52116 43.9502 8.68089 44.3443C7.82953 45.1685 7.30028 46.3234 7.30028 47.6019C7.30028 47.9424 7.33783 48.2742 7.40902 48.5933C6.63164 49.5634 6.16667 50.7946 6.16667 52.1344C6.16667 55.0241 8.3297 57.4086 11.125 57.7572V60.918V63.7513C11.125 64.1425 11.4421 64.4596 11.8333 64.4596C12.2245 64.4596 12.5417 64.1425 12.5417 63.7513V61.2114L13.7509 60.0022C14.0275 59.7256 14.0275 59.2771 13.7509 59.0004C13.4742 58.7238 13.0258 58.7238 12.7491 59.0004L12.5417 59.2079V57.7572ZM11.8333 48.8763C11.4421 48.8763 11.125 49.1934 11.125 49.5846V51.0013C11.125 51.3925 11.4421 51.7096 11.8333 51.7096C12.2245 51.7096 12.5417 51.3925 12.5417 51.0013V49.5846C12.5417 49.1934 12.2245 48.8763 11.8333 48.8763Z"
    })), _ref5 || (_ref5 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.0833 13.4596C17.6342 13.4596 18.954 14.4569 19.4329 15.8473L19.5752 16.2602L20.008 16.3186C21.3914 16.505 22.4583 17.6917 22.4583 19.1263C22.4583 20.6911 21.1898 21.9596 19.625 21.9596H11.125C9.56019 21.9596 8.29167 20.6911 8.29167 19.1263C8.29167 17.5615 9.56019 16.293 11.125 16.293H12.5761L12.743 15.8207C13.2295 14.4442 14.5424 13.4596 16.0833 13.4596ZM20.6179 14.9931C19.8475 13.2559 18.1078 12.043 16.0833 12.043C14.1045 12.043 12.3978 13.2019 11.6024 14.8763H11.125C8.77779 14.8763 6.875 16.7791 6.875 19.1263C6.875 21.4735 8.77779 23.3763 11.125 23.3763H19.625C21.9722 23.3763 23.875 21.4735 23.875 19.1263C23.875 17.1207 22.4864 15.4405 20.6179 14.9931Z"
    })), _ref6 || (_ref6 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M44.4167 48.1667H35.9167V62.3333H44.4167V48.1667ZM35.9167 46.75C35.1343 46.75 34.5 47.3843 34.5 48.1667V62.3333C34.5 63.1157 35.1343 63.75 35.9167 63.75H44.4167C45.1991 63.75 45.8333 63.1157 45.8333 62.3333V48.1667C45.8333 47.3843 45.1991 46.75 44.4167 46.75H35.9167Z"
    })), _ref7 || (_ref7 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M23.1667 41.793C23.5579 41.793 23.875 42.1101 23.875 42.5013V63.7513C23.875 64.1425 23.5579 64.4596 23.1667 64.4596C22.7755 64.4596 22.4583 64.1425 22.4583 63.7513V42.5013C22.4583 42.1101 22.7755 41.793 23.1667 41.793Z"
    })), _ref8 || (_ref8 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M57.875 47.4583C57.875 47.8495 57.5579 48.1667 57.1667 48.1667H23.1667C22.7755 48.1667 22.4583 47.8495 22.4583 47.4583C22.4583 47.0671 22.7755 46.75 23.1667 46.75H57.1667C57.5579 46.75 57.875 47.0671 57.875 47.4583Z"
    })), _ref9 || (_ref9 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M57.875 43.2096H22.4583V41.793H57.875V43.2096Z"
    })), _ref10 || (_ref10 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M47.9583 37.5417H32.375V36.125H47.9583V37.5417Z"
    })), _ref11 || (_ref11 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M35.2083 53.1263C35.2083 53.5175 34.8912 53.8346 34.5 53.8346H23.1667C22.7755 53.8346 22.4583 53.5175 22.4583 53.1263C22.4583 52.7351 22.7755 52.418 23.1667 52.418H34.5C34.8912 52.418 35.2083 52.7351 35.2083 53.1263Z"
    })), _ref12 || (_ref12 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M57.875 53.1263C57.875 53.5175 57.5579 53.8346 57.1667 53.8346H45.8333C45.4421 53.8346 45.125 53.5175 45.125 53.1263C45.125 52.7351 45.4421 52.418 45.8333 52.418H57.1667C57.5579 52.418 57.875 52.7351 57.875 53.1263Z"
    })), _ref13 || (_ref13 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M35.2083 58.7904C35.2083 59.1816 34.8912 59.4987 34.5 59.4987H23.1667C22.7755 59.4987 22.4583 59.1816 22.4583 58.7904C22.4583 58.3992 22.7755 58.082 23.1667 58.082H34.5C34.8912 58.082 35.2083 58.3992 35.2083 58.7904Z"
    })), _ref14 || (_ref14 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M57.875 58.7904C57.875 59.1816 57.5579 59.4987 57.1667 59.4987H45.8333C45.4421 59.4987 45.125 59.1816 45.125 58.7904C45.125 58.3992 45.4421 58.082 45.8333 58.082H57.1667C57.5579 58.082 57.875 58.3992 57.875 58.7904Z"
    })), _ref15 || (_ref15 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M28.125 64.457L28.125 38.957L29.5417 38.957L29.5417 64.457L28.125 64.457Z"
    })), _ref16 || (_ref16 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M50.7917 64.457L50.7917 38.957L52.2083 38.957L52.2083 64.457L50.7917 64.457Z"
    })), _ref17 || (_ref17 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M57.1667 41.793C57.5579 41.793 57.875 42.1101 57.875 42.5013V63.7513C57.875 64.1425 57.5579 64.4596 57.1667 64.4596C56.7755 64.4596 56.4583 64.1425 56.4583 63.7513V42.5013C56.4583 42.1101 56.7755 41.793 57.1667 41.793Z"
    })), _ref18 || (_ref18 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M39.4484 26.5159C39.8917 26.2551 40.4416 26.2551 40.8849 26.5159L63.9933 40.109C64.6718 40.5082 64.8948 41.3839 64.4898 42.059L63.0829 44.4037C62.6914 45.0563 61.8543 45.2829 61.187 44.917L40.1667 33.3897L19.1463 44.917C18.4791 45.2829 17.6419 45.0563 17.2504 44.4037L15.8436 42.059C15.4385 41.3839 15.6615 40.5082 16.3401 40.109L39.4484 26.5159ZM40.1667 27.737L17.0583 41.3301L18.4652 43.6748L39.4855 32.1476C39.9098 31.9149 40.4235 31.9149 40.8478 32.1476L61.8682 43.6748L63.275 41.3301L40.1667 27.737Z"
    })), _ref19 || (_ref19 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M30.9583 26.2096C30.9583 25.4272 30.3241 24.793 29.5417 24.793H25.2917C24.5093 24.793 23.875 25.4272 23.875 26.2096V36.1263H25.2917V26.2096L29.5417 26.2096V33.0895H30.9583V26.2096Z"
    })), _ref20 || (_ref20 =
    /*#__PURE__*/
    React.createElement("path", {
      d: "M38.75 55.9583C38.75 56.3495 38.4329 56.6667 38.0417 56.6667C37.6505 56.6667 37.3333 56.3495 37.3333 55.9583C37.3333 55.5671 37.6505 55.25 38.0417 55.25C38.4329 55.25 38.75 55.5671 38.75 55.9583Z"
    })))
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgCottage, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/cottage.980cc1d2.svg";
export { ForwardRef as ReactComponent };